import { render, staticRenderFns } from "./wlxq.vue?vue&type=template&id=45c15dae&scoped=true&"
import script from "./wlxq.vue?vue&type=script&lang=js&"
export * from "./wlxq.vue?vue&type=script&lang=js&"
import style0 from "./wlxq.vue?vue&type=style&index=0&id=45c15dae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c15dae",
  null
  
)

export default component.exports